import { render } from "./ImageCardShell.vue?vue&type=template&id=5fda2efe&scoped=true"
import script from "./ImageCardShell.vue?vue&type=script&lang=js"
export * from "./ImageCardShell.vue?vue&type=script&lang=js"

import "./ImageCardShell.vue?vue&type=style&index=0&id=5fda2efe&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fda2efe"]])

export default __exports__